exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AdminLayout-5252028b{max-width:1260px;margin:40px auto 120px auto;padding:0 30px}.AdminLayout-5252028b h1{margin-bottom:20px}.AdminLayout-5252028b.narrow-4037f623{max-width:760px;padding:0 30px}.prodWarn-6a17c96f{line-height:40px;color:#FFF;text-align:center;font-weight:500;background:linear-gradient(to right, #f12711, #f5af19)}.Grid-45d57c19{display:grid;grid-column-gap:30px;grid-row-gap:30px}@media screen and (max-width: 800px){.Grid-45d57c19{display:block}}.suggestionBox-33122e18{color:#757575;margin:100px 0 60px 0;text-align:center}\n", ""]);

// Exports
exports.locals = {
	"AdminLayout": "AdminLayout-5252028b",
	"narrow": "narrow-4037f623",
	"prodWarn": "prodWarn-6a17c96f",
	"Grid": "Grid-45d57c19",
	"suggestionBox": "suggestionBox-33122e18"
};